import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Gift, Sparkles } from 'lucide-react'
import useTelegramBackButton from '../hooks/useTelegramBackButton'
import AnimatedButton from '../components/AnimatedButton'
import { LOGO_SRC } from '../config/brand'

const Onboarding = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  // Интеграция кнопки "Назад" в Telegram (будет скрыта на странице онбординга)
  useTelegramBackButton()

  // ID приветственного кейса (захардкожен как требовалось)
  const WELCOME_CASE_ID = '00000000000000000000000000000000'

  // Обработчик клика на кнопку "Открой свой кейс"
  const handleOpenCase = () => {
    navigate(`/cases/${WELCOME_CASE_ID}/opening`, { 
        state: { allowOpening: true, fromOnboarding: true }
      })
  }

  return (
    <div className="min-h-screen bg-dark-primary text-white overflow-hidden relative">
      {/* Анимированный фон как в App.jsx */}
      <div className="animated-bg"></div>
      
      {/* Основной контент */}
      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6">
        
        {/* Декоративные элементы */}
        <div className="absolute top-20 left-10 opacity-20">
          <Sparkles size={32} className="text-accent-primary animate-pulse" />
        </div>
        <div className="absolute top-32 right-16 opacity-30">
          <Gift size={28} className="text-accent-secondary animate-bounce" />
        </div>
        <div className="absolute bottom-32 left-20 opacity-25">
          <Sparkles size={24} className="text-accent-primary animate-pulse" style={{ animationDelay: '1s' }} />
        </div>
        
        {/* Центральный контент */}
        <div className="text-center max-w-md space-y-8">
          
          {/* Заголовок SKINOZ */}
          <div className="mb-8">
            <div className="relative mb-4 inline-block">
              <img
                src={LOGO_SRC}
                alt="SKINOZ"
                className="relative z-10 mx-auto w-full max-w-[260px] sm:max-w-[300px]"
              />
              <div className="pointer-events-none absolute left-1/2 top-full h-8 w-3/4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-accent-primary/25 blur-2xl" />
            </div>
            
            {/* Описание */}
            <p className="text-xl text-text-secondary leading-relaxed">
              {t('onboarding.description')}<br />
              {t('onboarding.delivery')}
            </p>
          </div>

          {/* Декоративная иконка */}
          <div className="flex justify-center mb-8">
            <div className="relative" onClick={handleOpenCase}>
              <div className="w-20 h-20 bg-gradient-to-br from-accent-primary to-accent-secondary rounded-full flex items-center justify-center animate-pulse">
                <Gift size={40} className="text-dark-primary" />
              </div>
              
              {/* Светящиеся кольца вокруг иконки */}
              <div className="absolute inset-0 rounded-full border-2 border-accent-primary opacity-30 animate-ping"></div>
              <div className="absolute inset-0 rounded-full border border-accent-secondary opacity-20 animate-ping" style={{ animationDelay: '0.5s' }}></div>
            </div>
          </div>

          {/* Кнопка "Открой свой кейс" */}
          <AnimatedButton onClick={handleOpenCase}>
            <Gift size={24} />
            <span>{t('onboarding.openFree')}</span>
          </AnimatedButton>

          {/* Дополнительный текст */}
          <p className="text-sm text-text-secondary opacity-75 mt-6">
            {t('onboarding.getFirstSkin')}
          </p>
        </div>
      </div>
    </div>
  )
}

export default Onboarding
